/**
 * Created by stonewang on 2017/8/15.
 */
import _config from './config';

export {_config as config};
import _APIS from './services';

export {_APIS as APIS};
import _AjaxRequest from './ajaxRequest';

export {_AjaxRequest as request};
import _CookieUtils from './cookieUtils';

export {_CookieUtils as CookieUtils};
import {notification, Modal, message} from 'antd';
import numeral from 'numeral';

// 连字符转驼峰
String.prototype.hyphenToHump = function () {
    return this.replace(/-(\w)/g, function () {
        return arguments[1].toUpperCase()
    })
};

// 驼峰转连字符
String.prototype.humpToHyphen = function () {
    return this.replace(/([A-Z])/g, "-$1").toLowerCase()
};

// 数据容量单位转换
Number.prototype.bytesToSize = function () {
    if (this === 0) return '0 b';
    let k = 1024, // or 1024
        sizes = ['b', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'],
        i = Math.floor(Math.log(this) / Math.log(k));
    return (this / Math.pow(k, i)).toPrecision(3) + sizes[i];
};
// 日期格式化
Date.prototype.format = function (format) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        'H+': this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    }
    if (/(y+)/.test(format))
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length))
    for (var k in o)
        if (new RegExp("(" + k + ")").test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length))
    return format
};

export const str2json = (str) => {
    let t = null;
    try {
        t = JSON.parse(str);
    } catch (e) {
        t = eval("(" + str + ')');
    } finally {
        return t;
    }
};
export const isNull = (x) => {
    if (x === null || x === undefined || x === 'null' || x === 'undefined' || x === '') {
        return true;
    }
    return false;
};
//带千分位的数字
export const formatMoney = (num) => {
    if (typeof num == 'number') {
        num = num.toFixed(2);
    }
    num = (num || 0).toString();
    var result = ''
        , dec = ''
        , temp = '';
    if (num.match('.')) {
        var t = num.split('.');
        num = t[0];
        if (t.length > 1)
            dec = t[1];
    }
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
    }
    if (num) {
        result = num + result;
    }
    while (dec.length > 3) {
        temp = dec.slice(0, 3) + ',' + temp;
        dec = dec.slice(3);
    }
    if (dec) {
        temp = temp + dec;
    } else {
        if (temp)
            temp = temp.slice(0, temp.length - 2);
    }
    return (dec ? (result + '.' + temp) : result);
};
//数字金额转中文大写金额
export const ZHDX = (n) => {
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
        return "数据非法";
    }
    let unit = "千百拾亿千百拾万千百拾元角分", str = "";
    n += "00";
    let p = n.indexOf('.');
    if (p >= 0)
        n = n.substring(0, p) + n.substr(p + 1, 2);
    unit = unit.substr(unit.length - n.length);
    for (let i = 0; i < n.length; i++) {
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    }
    return str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
};
//对象序列化
export const objectSerial = (data) => {
    let params = '';
    if (data) {
        for (var o in data) {
            if (data[o] !== null && data[o] !== undefined && data[o] !== '') {

                if (typeof data[o] === 'object' && data[o] instanceof Array && data[o].length > 0) {
                    if (typeof data[o][0] === 'object') {
                        params += (o + '=' + JSON.stringify(data[o]) + '&')
                    } else {
                        for (var i = 0; i < data[o].length; i++) {
                            params += (o + '=' + data[o][i] + '&')
                        }
                    }
                } else {
                    params += (o + '=' + data[o] + '&')
                }
            }
        }
    }

    if (params.length > 0) {
        params = params.substr(0, params.length - 1);
    }
    return params;
};
//消息弹框 对 notification 的封装
export const openNotice = (type, message, desc, duration) => {
    notification[type]({
        message: message,
        description: desc,
        duration: duration || 5
    });
};
//带关闭按钮的消息弹框 对 Modal 的封装
export const openModal = (type, title, msg) => {
    Modal[type]({
        title: title,
        content: msg,
        okText: '关闭'
    });
};
// 距当前事件多少
export const getRemainTime = (str) => {
    var now = new Date();
    var zero = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);//零点时分
    var oneMin = 1000 * 60;//一分钟
    var oneHour = 1000 * 60 * 60;//一个小时
    var oneDay = 1000 * 60 * 60 * 24;//24小时
    /*
     var dateIndex = now.getDate();//今天是第几号
     var weekIndex = now.getDay();//今天是周几
     */
    var result = '';
    if (str) {
        str = str.split(/-| |:/);
        var t = new Date(parseInt(str[0], 10), parseInt(str[1], 10) - 1, parseInt(str[2], 10), parseInt(str[3], 10), parseInt(str[4], 10), parseInt(str[5] || 0, 10));
        var sub1 = now.getTime() - t.getTime();//数据创建时间距离当前时间的差值
        var sub2 = zero.getTime() - t.getTime();//数据创建时间距离今天零点时分的差值
        if (sub2 > 0) {//数据创建时间早于今天0点
            if (sub2 <= oneDay) {//是昨天，则显示：昨天 xx时xx分
                var h1 = t.getHours();
                var m1 = t.getMinutes();
                h1 = (h1 < 10 ? ('0' + h1) : h1);
                m1 = (m1 < 10 ? ('0' + m1) : m1);

                result = '昨天 ' + h1 + '时' + m1 + '分';
            } else {
                /*
                 var td = {dateIndex: dateIndex, weekIndex: weekIndex};
                 var o = {dateIndex: t.getDate(), weekIndex: t.getDay()};
                 */
                /* 修改 */
                var M1 = t.getMonth() + 1;
                var D1 = t.getDate();
                M1 = (M1 < 10 ? ('0' + M1) : M1);
                D1 = (D1 < 10 ? ('0' + D1) : D1);
                var h3 = t.getHours();
                var m3 = t.getMinutes();
                h3 = (h3 < 10 ? ('0' + h3) : h3);
                m3 = (m3 < 10 ? ('0' + m3) : m3);

                result = M1 + '月' + D1 + '日 ' + h3 + ':' + m3;//例如：10月18日 10:55

                if (now.getFullYear() != t.getFullYear()) {//例如：2015年10月18日 10:55
                    result = t.getFullYear() + result;
                }
                /*
                 if (isSameWeek(td, o)) {//星期x xx时xx分（例如：星期三 11:22）
                 var h2 = t.getHours();
                 var m2 = t.getMinutes();
                 h2 = (h2 < 10 ? ('0' + h2) : h2);
                 m2 = (m2 < 10 ? ('0' + m2) : m2);

                 var d1 = t.getDay();
                 var weekday = new Array(7);
                 weekday[0] = "星期日";
                 weekday[1] = "星期一";
                 weekday[2] = "星期二";
                 weekday[3] = "星期三";
                 weekday[4] = "星期四";
                 weekday[5] = "星期五";
                 weekday[6] = "星期六";

                 result = weekday[d1] + ' ' + h2 + ':' + m2;
                 } else {
                 var M1 = t.getMonth() + 1;
                 var D1 = t.getDate();
                 M1 = (M1 < 10 ? ('0' + M1) : M1);
                 D1 = (D1 < 10 ? ('0' + D1) : D1);
                 var h3 = t.getHours();
                 var m3 = t.getMinutes();
                 h3 = (h3 < 10 ? ('0' + h3) : h3);
                 m3 = (m3 < 10 ? ('0' + m3) : m3);

                 result = M1 + '月' + D1 + '日 ' + h3 + ':' + m3;//例如：10月18日 10:55

                 if (now.getFullYear() != t.getFullYear()) {//例如：2015年10月18日 10:55
                 result = t.getFullYear() + result;
                 }
                 }
                 */
            }
        } else {
            if (sub1 < oneHour) {//距离时间不足1小时，显示xx分钟前
                result = parseInt(sub1 / oneMin, 10) + '分钟前';
            } else if (sub1 <= oneDay) {//超过1小时且仍未今天00:00分后的通知，显示x小时前
                result = parseInt(sub1 / oneHour, 10) + '小时前';
            }
        }
    }
    return result;

    /*
     function isSameWeek(today, other) {
     if (today.dateIndex > other.dateIndex) {
     if ((today.dateIndex - other.dateIndex) <= 6 && (today.weekIndex - other.weekIndex) <= 6) {
     return true;
     } else {
     return false;
     }
     } else if (today.dateIndex < other.dateIndex) {
     if ((other.dateIndex - today.dateIndex) <= 6 && (other.weekIndex - today.weekIndex) <= 6) {
     return true;
     } else {
     return false;
     }
     } else {
     return true;
     }
     }
     */
};

export function showSpin() {
    var event = new Event('showSpin');
    document.dispatchEvent(event);
}

export function hideSpin() {
    var event = new Event('hideSpin');
    document.dispatchEvent(event);
}

export function unique(arr, key) {
    const result = [];
    const obj = {};

    if (key) {
        for (const i of arr) {
            if (!obj[i[key]]) {
                result.push(i);
                obj[i[key]] = 1
            }
        }
    } else {
        for (const i of arr) {
            if (!obj[i]) {
                result.push(i);
                obj[i] = 1
            }
        }
    }
    return result
}

//数字保留两位小数
export function toFixed2(num) {
    if (!num) return null;
    num = parseFloat(num) * 100;
    return Math.round(num) / 100;
}

/* 列表Excel导出(天正电气)
 param: {
 rows [
 id: ''  // 列表ID
 ],
 path: ''  // 请求接口
 prefix: ''  // 拼接前缀
 }
 */
export function exportExcel(param) {
    let _rows = param.rows
        , _path = param.path
        , _arr = []
        , _obj = {}
        , _fix = param.prefix || 'ids'
    ;
    if (!_rows.length) {
        message.warning('当前列表无数据，不能导出');
    }
    _rows.map(x => {
        // _arr.push('ids=' + x.id);
        _arr.push(_fix + '=' + x.id);
    });
    _obj = _arr.join('&');
    window.location.href = `${_config.server}/api/v1/dms${_path}?${_obj}`;
}

/* 下载模板
 type: 1  // 1：二级客户、2: 其他产品、3：子库存
 */
export function downLoadTemplate(type) {
    window.location.href = `${_config.server}/api/v1/common/downExcel/downLoadExcelModule?id=${type}`;
}

/* 导入
 type: 1  // 1：二级客户、2: 其他产品、3：子库存、8：产品规格；9：产品；10：事务处理订单
 */
export function toImportExcel(type, callback) {
    let _param = {
        action: `${_config.server}/api/v1/common/downExcel/excelImport`,
        beforeUpload: res => {
            return new Promise((resolve, reject) => {
                let _arr = res.name.split('.')
                    , _tar = _arr[_arr.length - 1]
                ;
                if (_tar != 'xls' && _tar != 'xlsx') {
                    message.warning('请上传从模板下载的Excel文件');
                    return
                }
                if (res.size > 5242880) {
                    message.warning('上传的文件过大，不能超过5M');
                    return
                }
                Modal.warning({title: "注意", content: "正在导入，请勿其他操作，等待系统提示！"});
                resolve();
            });
        },
        onChange: res => {
            if (res.file.status !== 'uploading') {
                console.log(res.file, res.fileList);
            }
            if (res.file.status === 'done') {
                if (res.file.response.status) {
                    if (res.file.response.message) {
                        message.warning(res.file.response.message);
                    } else {
                        message.success('导入成功', 3);
                    }
                    if (typeof callback == 'function') {
                        callback();
                    }
                } else {
                    message.error(res.file.response.message, 3);
                }
            } else if (res.file.status === 'error') {
                message.error('上传文件失败');
            }
        },
        className: type !== 9 ? 'toImportBtn' : '',
        showUploadList: false,
        data: (file) => {
            // console.log(file);
            return {
                uploadFile: file,
                type: type,
            }
        }
    }
    return _param;
}

export function toImportExcel1(orderType, channelCode, customerId, purchaseId, receiveAddressId, flowCode, pickProAddress, callback) {

    let _param = {
        action: `${_config.server}/api/v1/common/downExcel/excelImportOrderPro`,
        beforeUpload: res => {
            return new Promise((resolve, reject) => {
                let _arr = res.name.split('.')
                    , _tar = _arr[_arr.length - 1]
                ;
                if (_tar != 'xls' && _tar != 'xlsx') {
                    message.warning('请上传从模板下载的Excel文件');
                    return
                }
                if (res.size > 5242880) {
                    message.warning('上传的文件过大，不能超过5M');
                    return
                }
                Modal.warning({title: "注意", content: "正在导入，请勿其他操作，等待系统提示！"});
                resolve();
            });
        },
        onChange: res => {
            if (res.file.status !== 'uploading') {
                console.log(res.file, res.fileList);
            }
            if (res.file.status === 'done') {
                if (res.file.response.status) {
                    //console.log(res);
                    var result = res.file.response.data;
                    message.success(res.file.response.message, 3);
                    if (typeof callback == 'function') {
                        // console.log(result)
                        callback(result);
                    }
                } else {
                    //message.error(res.file.response.message, 3);
                    Modal.error({title: "导入情况", content: res.file.response.message});
                }
            } else if (res.file.status === 'error') {
                if (!receiveAddressId) {
                    message.warning('请选择实际收货地址');
                    return
                } else {
                    message.error('上传文件失败');
                }
            }
        },
        className: 'toImportBtn',
        showUploadList: false,
        data: (file) => {
            // console.log(file);
            // debugger
            return {
                uploadFile: file,
                // type: type,
                orderType: orderType,
                channelCode: channelCode,
                customerId: customerId,
                purchaseId: purchaseId,
                receiveAddressId: receiveAddressId,
                flowCode: flowCode,
                pickProAddress: pickProAddress,
            }
        }
    }
    return _param;
}

export function toImportExcel2(type, callback) {
    let _param = {
        action: `${_config.server}/api/v1/common/downExcel/excelImport`,
        beforeUpload: res => {
            return new Promise((resolve, reject) => {
                let _arr = res.name.split('.')
                    , _tar = _arr[_arr.length - 1]
                ;
                if (_tar != 'xls' && _tar != 'xlsx') {
                    message.warning('请上传从模板下载的Excel文件');
                    return
                }
                if (res.size > 5242880) {
                    message.warning('上传的文件过大，不能超过5M');
                    return
                }
                Modal.warning({title: "注意", content: "正在导入，请勿其他操作，等待系统提示！"});
                resolve();
            });
        },
        onChange: res => {
            if (res.file.status !== 'uploading') {
                console.log(res.file, res.fileList);
            }
            if (res.file.status === 'done') {
                if (res.file.response.status) {
                    var result = res.file.response.data;
                    message.success('导入成功', 3);
                    if (typeof callback == 'function') {
                        callback(result);
                    }
                } else {
                    message.error(res.file.response.message, 3);
                }
            } else if (res.file.status === 'error') {
                message.error('上传文件失败');
            }
        },
        className: 'toImportBtn',
        showUploadList: false,
        data: (file) => {
            // console.log(file);
            return {
                uploadFile: file,
                type: type,
            }
        }
    }
    return _param;
}

export function changeCart() {
    let event = document.createEvent('Event');
    event.initEvent('changeCart', true, true);
    document.dispatchEvent(event);
}

export function changeOrderLength() {
    let event = document.createEvent('Event');
    event.initEvent('changeOrderLength', true, true);
    document.dispatchEvent(event);
}

//保留两位小数
export const returnFloat = (value, unit = '') => {
    /*var value1 = Math.round(parseFloat(value) * 100) / 100;
    var xsd = value1.toString().split(".");
    if (xsd.length == 1) {
        value1 = value1.toString() + ".00";
        return value1;
    }
    if (xsd.length > 1) {
        if (xsd[1].length < 2) {
            value1 = value1.toString() + "0";
        }
        return value1;
    }*/
    if (!isNull(value) && /^\d+(\.\d+)?$/.test(value.toString())) {
        var number = numeral(value);
        numeral.defaultFormat('0,0.00');
        return unit + ` ${number.format()}`;
    }
    return ''
}

export function setEvaluatePage({detail, orderProductId}) {
    let productList = [];
    let logisticsEvaluation = {};
    if (orderProductId) {
        //filter 过滤已评价的产品
        productList = detail.productList.filter(x => (x.id === orderProductId && !x.evaluationCount)).map(x => ({
            'productPicUrl': x.picUrl,
            'productName': x.productName,
            'productSpec': x.specUnionKey,
            'price': x.price,
            'orderProductId': x.id,
            'orderId': detail.id,
            'score': 0,
            'evaluation': '',
            'picFileIdList': [],
            'picFileList': [],
        }))
    } else {
        //filter 过滤已评价的产品
        productList = detail.productList.filter(x => !x.evaluationCount).map(x => ({
            'productPicUrl': x.picUrl,
            'productName': x.productName,
            'productSpec': x.specUnionKey,
            'price': x.price,
            'orderProductId': x.id,
            'orderId': detail.id,
            'score': 0,
            'evaluation': '',
            'picFileIdList': [],
        }));
        logisticsEvaluation = {
            'orderId': detail.id,
            'packScore': '', /* 商品包装 */
            'speedScore': '', /* 送货速度 */
            'attitudeScore': '' /* 配送员服务态度 */
        };
    }
    localStorage.setItem('EvaluatePage', JSON.stringify({logisticsEvaluation, productList}))
}

export const getDecimal = (x, precision) => {
    var n = precision || 2;
    var fx = parseFloat(x);
    if (isNaN(fx)) {
        window.console.error('function:getTwoDecimal->parameter error');
        return false;
    }
    fx = Math.round(fx * 100) / 100;
    var sx = fx.toString();
    var posDecimal = sx.indexOf('.');
    if (posDecimal < 0) {
        posDecimal = sx.length;
        sx += '.';
    }
    while (sx.length <= posDecimal + n) {
        sx += '0';
    }
    return sx; //parseFloat(sx);
}
export const proLineSet = [
    {
        value: '01', text: '元器件'
    },
    {
        value: '02', text: '电工'
    },
    {
        value: '03', text: '电表'
    },
    {
        value: '04', text: '变频器'
    },
    {
        value: '05', text: '天e'
    },
    {
        value: '06', text: 'TG精品'
    },
];



// WEBPACK FOOTER //
// ./src/utils/index.js